// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_10nW4t--style-module--wrapper","item":"UWbv7h--style-module--item"};